<template>
  <div class="iv-appra-declare-enroll">
    <ApplyStep :stepData="stepData" />
    <div class="iv-p-t-40 iv-enroll-content">
      <div class="iv-main-width iv-p-b-40">
        <section>
          <div class="iv-app-detail-fill iv-m-b-20">
            <h1 class="iv-fs-24 iv-fc-85 iv-vertical-line">BOE员工职业操守宣言</h1>
          </div>
        </section>
        <section class="iv-p-b-40">
         <LayoutTitle title="下发签署人">
            <FormLayout :model="baseInfo" :list="baseForm"></FormLayout>
         </LayoutTitle>
        </section>
        <section class="iv-p-b-40">
         <LayoutTitle title="职业操守签署宣言文件">
            <DragTable
              class="iv-m-t-24 iv-p-b-40"
              noUrl
              noSearch 
              :showSelect="false" 
              ref="DragTable1"
              :showDelete="false"
              :showPage="false"
              :showEdit="false"
              :immediateForce="true"
              :columns="columns" 
              :tableData="tableData">
            </DragTable>
         </LayoutTitle>
        </section>
      </div>
    </div>
    <FooterOperator>
      <Button v-if="type != 'see'" class="iv-m-r-8" type="submit" @click="submit">提交</Button>
      <Button type="back" @click="back">返回</Button>
    </FooterOperator>
    <Modal
      ref="Modal"
      :title="'下载模板'"
      v-model="showModal"
      :size="'small'"
      >
      <ul v-if="fileList.length > 0" class="iv-m-l-16 iv-m-t-16">
        <li class="iv-m-b-16 iv-fs-16 iv-main-color iv-pointer iv-hover-color" style="text-decoration: underline;" v-for="(item, index) in fileList" :key="index" @click="fileDown(type, item)">
          {{item.fileName}}
        </li>
      </ul>
      <div class="iv-m-l-16 iv-m-t-16 iv-m-b-16 iv-fs-16" v-else>
        暂未上传模板文件
      </div>
      <div slot="footer">
        <Button type="sure" @click="hidedenModal">关闭</Button>
      </div>
      </Modal>
    <!-- <Spin size="large" fix v-if="spinShow"></Spin> -->
  </div>
</template>

<script>
import ApplyStep from '../components/apply-step.vue'
import columns from './columns'
import Modal from '@/components/modal'
import baseForm from './baseInfo'
import DragTable from '@/components/drag-table-inline'
import FormLayout from '@/components/layout/form'
import FooterOperator from '@/components/footer-operator'
import LayoutTitle from '@/components/layout/layout-title'
import { getSignInfo, oneselfSign } from '../interface/index.js'
import { timeFormat } from '@/utils'
// import {prefixPath} from '@/config'
export default {
  data () {
    return {
      stepData: [{
        step: 1,
        status: 'complete',
        title: '创建签署通知'
      },
      {
        step: 2,
        status: 'complete',
        title: '下发通知'
      },
      {
        step: 3,
        status: 'complete',
        title: '维护签署人'
      },
      {
        step: 4,
        status: 'ongoing',
        title: '签署人签署'
      },
      {
        step: 5,
        status: 'wait',
        title: '上报签署文件'
      },
      {
        step: 5,
        status: 'wait',
        title: '完成签署'
      }],
      type: this.$route.query.type,
      scopeId: this.$route.query.scopeId,
      isSign: '',
      baseForm: [],
      baseInfo: {},
      columns: [],
      tableData: [],
      dictMap: {},
      fileId: '',
      showModal: false,
      fileList: []
    }
  },
  created () {
    Promise.all([this.getCodeTable('DM14'), this.getCodeTable('GB4762')]).then(res => {
      this.getUserInfo()
      this.getInfo()
    })
    this.baseForm = baseForm.call(this)
    this.columns = columns.call(this)
    if (this.type == 'see') {
      this.stepData[3].status = 'complete'
    }
  },
  methods: {
    timeFormat,
    //提交
    submit () {
      if (!this.fileId) {
        this.$Message.warning('请上传签字文件')
        return 
      }
      oneselfSign({
        signFile: this.fileId,
        scopeId: this.baseInfo.scopeId
      }).then(({data}) => {
        this.$Message.success('提交成功')
        this.back()
      })
    },
    getFilePath (type) {
      this.showModal = true
      this.$methods('Modal', 'open')
    },
    fileDown (type, item) {
      let url = ''
      if (type == 'see') {
        url = `api-uum/file/downloadFile?fileId=${this.baseInfo.signFile}&access_token=${sessionStorage.getItem('token')}`
      } else {
        url = `api-uum/file/downloadFile?fileId=${item.fileId}&access_token=${sessionStorage.getItem('token')}`
      }
      window.open(url)
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: 'YWX01'
          }
        }).then(({data}) => {
          data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    },
    fileSubmit (fileId) {
      this.fileId = fileId
    },
    //获取详情
    getInfo () {
      getSignInfo({
        scopeId: this.scopeId
      }).then(data => {
        this.baseInfo = data.data
        this.isSign = data.data.isSign
        this.baseInfo.startDate = timeFormat(this.baseInfo.startDate)
        this.baseInfo.endDate = timeFormat(this.baseInfo.endDate)
        this.getActivityFiles(this.baseInfo.fileInfo)
      })
    },
    //获取文件信息
    getActivityFiles (groupId) {
      this.$ajax({
        url: 'api-uum/file/listFilesByGroupId',
        method: 'GET',
        data: {
          isPage: false,
          groupId: groupId
        }
      }).then(({data}) => {
        let res = data.data
        this.fileList = res
      })
    },
    //获取用户信息
    getUserInfo () {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-uum/uuminfo/getUserInfo',
          method: 'get',
          data: {}
        }).then(({data}) => {
          const userInfo = data.data
          this.tableData = [{
            orgName: userInfo.orgName,
            logYear: userInfo.logYear ? userInfo.logYear + '' : timeFormat(new Date(), 'yyyy'),
            capitaMonthlyIncome: null,
            familyPopulation: null,
            userName: userInfo.userName,
            userId: userInfo.userId,
            userCode: userInfo.userCode,
            phone: userInfo.mobile,
            email: userInfo.email,
            gender: userInfo.sex == '女' ? '2' : '1',
            political: userInfo.polity,
            applyType: '01',
            createTime: timeFormat(new Date()),
            reportDate: timeFormat(new Date()),
            idCardNum: userInfo.idCardNum,
            birthday: timeFormat(userInfo.birthday),
            nation: userInfo.nationnality,
            familyAddr: userInfo.familyAddress,
            education: userInfo.highestEducation
          }]
          resolve()
        })
      })
    },
    back () {
      this.$router.go(-1)
    },
    hidedenModal() {
      this.showModal = false
    }
  },
  components: {
    ApplyStep,
    DragTable,
    FormLayout,
    FooterOperator,
    LayoutTitle,
    Modal
  }
}
</script>

<style lang="scss" scoped>
.iv-appra-declare-enroll {
  .iv-enroll-top {
    background: #F5F7FA;
    .iv-enroll-top-expand {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    .iv-enroll-top-description {
      display: flex;
    }
  }
  .iv-app-detail-fill {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .iv-enroll-content {
    background: #fff;
    .iv-enroll-content-ul {
      overflow: hidden;
      li {
        width: 282px;
        padding: 18px 26px;
        border-radius: 16px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        margin-right: 24px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:hover {
          font-weight: bold;
          color: #FA2900 !important;
          border-color: #FA2900;
        }
        &.iv-enroll-active {
          font-weight: bold;
          color: #FA2900 !important;
          border-color: #FA2900;
        }
      }  
    }    
    .iv-enroll-content-desc {
      background-color: #F5F7FA;
      border-radius: 16px;
      padding: 20px 24px;
    }    
    .iv-enroll-content-selcect {
      color: #FA2900;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      text-decoration: underline;
      font-weight: 400;
    }
    .iv-enroll-block {
      h3 {
        border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
